<template>
  <sui-segment attached="bottom">
    <sui-table size="large" celled>
      <sui-table-header>
        <sui-table-row>
          <sui-table-header-cell>Roles</sui-table-header-cell>
        </sui-table-row>
      </sui-table-header>
      <sui-table-body v-show="!roles.length">
        <sui-table-row>
          <sui-table-cell>
            No roles
          </sui-table-cell>
        </sui-table-row>
      </sui-table-body>
      <sui-table-body v-show="roles.length">
        <sui-table-row v-for="r in roles" :key="r.id">
          <sui-table-cell>
            <div class="entity">
              <i class="entity-icon tag icon" />
              <div class="entity-info">
                <b>{{r.name}}</b>
              </div>
              <sui-button class="entity-button" size="tiny" icon="cog" color="blue" data-goal="ACCOUNT_ROLES_EDIT" basic @click.prevent="$modals.updateRole.open(r)" />
            </div>
          </sui-table-cell>
        </sui-table-row>
      </sui-table-body>
      <sui-table-footer>
        <sui-table-row>
          <sui-table-header-cell>
            <sui-button color="green" size="small" icon="plus" label-position="left" :disabled="!access.accManagement || !account.limits.invite" data-goal="ACCOUNT_ROLES_ADD" @click.prevent="$modals.createRole.open()">Add role</sui-button>
          </sui-table-header-cell>
        </sui-table-row>
      </sui-table-footer>
    </sui-table>
    <sui-message error v-if="apiErrors">
      {{apiErrors}}
    </sui-message>
  </sui-segment>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'AccountRolesView',
    data() {
      return {
        apiErrors: null,
      }
    },
    computed: {
      ...mapGetters(['access', 'account', 'roles']),
    },
  }
</script>

<style scoped>
  small { font-size: .8em; color: #999; }
  .entity { display: flex; align-items: center; }
  .entity-button { margin: 0 0 0 .5em!important; }
  .entity-icon { font-size: 1.8em; vertical-align: middle; margin-right: .5em; }
  .entity-info { flex: 1; }
  .entity-limits { float: right; text-align: right; line-height: 1.2; }
  .entity-logo { margin-right: .5em; height: 2em!important; width: 2em!important; border-radius: .2em; }
</style>
